const LAST_PLAYED_STORAGE_KEY = 'coachSeasonalLogo.lastAutoPlayedAt'
const AUTO_PLAY_INTERVAL_MS = 30 * 60 * 1000
const SHARED_DECISION_WINDOW_MS = 5 * 1000

let lastDecision

/**
 * The animation plays on its own at most once every 30 minutes per browser, so
 * it stays a treat instead of replaying on every page load. Logos that mount
 * together (the header can render the logo more than once) share one decision.
 * A stored timestamp in the future counts as due; unavailable storage never
 * auto-plays.
 */
export const shouldAutoPlay = () => {
  const now = Date.now()
  if (
    lastDecision &&
    now - lastDecision.decidedAt < SHARED_DECISION_WINDOW_MS
  ) {
    return lastDecision.due
  }

  try {
    const lastPlayedAt = Number(
      window.localStorage.getItem(LAST_PLAYED_STORAGE_KEY),
    )
    const elapsed = now - lastPlayedAt
    const due = !(elapsed >= 0 && elapsed < AUTO_PLAY_INTERVAL_MS)
    if (due) {
      window.localStorage.setItem(LAST_PLAYED_STORAGE_KEY, String(now))
    }
    lastDecision = { due, decidedAt: now }
  } catch (error) {
    lastDecision = { due: false, decidedAt: now }
  }

  return lastDecision.due
}

/** Test helper: forgets the shared decision so the next mount decides again. */
export const resetAutoPlayDecision = () => {
  lastDecision = undefined
}

/** Test helper: also forgets the stored last auto-play time. */
export const clearAutoPlayHistory = () => {
  resetAutoPlayDecision()
  try {
    window.localStorage.removeItem(LAST_PLAYED_STORAGE_KEY)
  } catch (error) {
    // Storage is unavailable, so there is no history to clear.
  }
}
